<template>
	<v-container class="border-container">
		<v-row align="center" justify="center">
			<v-col cols="auto">
				<h1 style="margin-bottom: 30px;">Sustainability Score Map of</h1>
			</v-col>
			<v-col cols="auto">
				<div class="matrix-select">
					<v-select
						v-model="selectedType"
						:items="EsgType"
						outlined
						dense
						style="width: 170px;"
					></v-select>
				</div>
			</v-col>
		</v-row>

		<v-tabs
			background-color="transparent"
			light
			icons-and-text
			v-model="selectedTab"
		>
			<v-tab>
				World Map
			</v-tab>
			<v-tab>
				Connection Map
			</v-tab>
		</v-tabs>

		<component :is="currentComponent" />
	</v-container>
</template>

<script>
import WorldMapHR from "./WorldMapHR.vue"
import WorldMapLB from "./WorldMapLB.vue"
import WorldMapEN from "./WorldMapEN.vue"
import WorldMapAC from "./WorldMapAC.vue"
import ConnectionMapHR from "./ConnectionMapHR.vue"
import ConnectionMapLB from "./ConnectionMapLB.vue"
import ConnectionMapEN from "./ConnectionMapEN.vue"
import ConnectionMapAC from "./ConnectionMapAC.vue"

export default {
	components: {
		WorldMapHR,
		WorldMapLB,
		WorldMapEN,
		WorldMapAC,
		ConnectionMapHR,
		ConnectionMapLB,
		ConnectionMapEN,
		ConnectionMapAC,
	},
	data() {
		return {
			selectedType: "Human Rights",
			EsgType: ["Human Rights", "Labour", "Environment", "Anticorruption"],
			selectedTab: 0,
		}
	},
	computed: {
		currentComponent() {
			const typeMapping = {
				"Human Rights": {
					world: WorldMapHR,
					connection: ConnectionMapHR,
				},
				Labour: {
					world: WorldMapLB,
					connection: ConnectionMapLB,
				},
				Environment: {
					world: WorldMapEN,
					connection: ConnectionMapEN,
				},
				Anticorruption: {
					world: WorldMapAC,
					connection: ConnectionMapAC,
				},
			}

			const currentMapType = this.selectedTab === 0 ? "world" : "connection"
			return typeMapping[this.selectedType][currentMapType]
		},
	},
}
</script>

<style scoped>
.border-container {
	border: 1px solid black;
}

.no-shadow {
	box-shadow: none !important;
}

.custom-btn {
	font-size: 18px !important;
	font-weight: bold;
}
</style>
